import { Customer } from '@kinet-open-network/client/customers/data-access';

export class AppCustomer extends Customer {
  externalNumber?: string;
  deliveryFeeSku?: string;
  isStock?: boolean;
  isSupplier?: boolean;
  isFillingPlant?: boolean;
  onixId?: number;
}
